import { render } from "./UserSearchResults.vue?vue&type=template&id=a2cb4aba&scoped=true&lang=pug"
import script from "./UserSearchResults.vue?vue&type=script&lang=js"
export * from "./UserSearchResults.vue?vue&type=script&lang=js"

import "./UserSearchResults.vue?vue&type=style&index=0&id=a2cb4aba&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2cb4aba"]])

export default __exports__